import * as React from "react";

const NISUpIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3.50024 9.87488C3.50024 9.68298 3.57349 9.49098 3.71997 9.34473L7.46997 5.59473C7.76294 5.30176 8.23755 5.30176 8.53052 5.59473L12.2805 9.34473C12.5735 9.63769 12.5735 10.1123 12.2805 10.4053C11.9875 10.6982 11.5129 10.6982 11.22 10.4053L8.00024 7.18543L4.77993 10.4057C4.48696 10.6987 4.01235 10.6987 3.71938 10.4057C3.5729 10.2593 3.50024 10.0671 3.50024 9.87488Z" fill="#333333" />
        </svg>
    );
};

export default React.memo(NISUpIcon);
